import React from "react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

export default function DangerZone({ onDelete }) {
  return (
    <div className="border-b border-border-strong pb-4">
      <div className="flex flex-wrap items-center gap-3 p-4 rounded-xl bg-destructive-50 border border-border-destructive">
        <ExclamationTriangleIcon className="h-5 w-5 text-destructive mt-0.5" />
        <div className="flex-1">
          <h3 className="text-sm font-semibold text-text-primary">
            Danger zone
          </h3>
          <p className="text-sm text-text-primary">
            Delete account permanently. This action cannot be undone.
          </p>
        </div>
        <button
          type="button"
          onClick={onDelete}
          className="px-3 py-1.5 rounded-md border border-border-light text-text-primary text-sm bg-surface-elevated hover:bg-surface ml-auto w-full sm:w-auto mt-2 sm:mt-0"
        >
          Delete account
        </button>
      </div>
    </div>
  );
}
